<script setup lang="ts">
import { computed, type Ref, ref } from 'vue';
import { RBtn } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';
import { resources, ResourceTab } from '@/models/Resources';
import ResourcesList from '@/components/resources/ResourcesList.vue';
import CatalogAdditions from '@/components/resources/CatalogAdditions.vue';

const currentResourceTab: Ref<ResourceTab> = ref(ResourceTab.CATALOGUE);

const { $gettext } = gettext;

const resourcesButtonTextMapping = computed(() => {
  return {
    [ResourceTab.CATALOGUE]: $gettext('Catalogue'),
    [ResourceTab.WHITE_PAPERS]: $gettext('White Papers'),
    [ResourceTab.SUCCESS_STORIES]: $gettext('Success Stories'),
    [ResourceTab.TECHNICAL_DATA]: $gettext('Technical Data'),
    [ResourceTab.VIDEOS]: $gettext('Videos'),
    [ResourceTab.OTHER]: $gettext('Other'),
  };
});
</script>

<template>
  <div class="pa-4 pa-sm-12">
    <v-row>
      <v-col class="mb-4">
        <h1>
          {{ $gettext('Resources') }}
        </h1>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col
        ><img
          src="@/assets/robco-productionline-render.png"
          alt="RobCo production line"
          class="mb-3 w-50"
          style="max-width: 500px"
          contain
      /></v-col>
    </v-row>
    <v-row class="mb-5">
      <v-col
        v-for="(entry, key) in resourcesButtonTextMapping"
        v-bind:key="key"
        cols="6"
        md
        xl="auto"
      >
        <r-btn
          class="w-100"
          :inactive="currentResourceTab !== key"
          @click="currentResourceTab = key"
          >{{ entry }}
        </r-btn>
      </v-col>
    </v-row>

    <resources-list :entries="resources[currentResourceTab]" />
    <catalog-additions v-if="currentResourceTab === ResourceTab.CATALOGUE" />
  </div>
</template>
